<!--
  src/components/DialogDayComments.vue
  Edit the admin's note for ONE plan day, keyed (CourseId, ProgramTypeId) + TaskDate.
  Loads the current note on open; saving a blank note clears the day.
  Backend: TasksService.getPlanDayComments / setPlanDayComments.
-->
<template>
  <div class="DialogDayComments">
    <div class="modal-card" style="width: 520px;">
      <header class="modal-card-head">
        <p class="modal-card-title">הערה ליום {{ displayDate }}</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>

      <section class="modal-card-body">
        <b-field label="הערת היום">
          <b-input type="textarea" v-model="comments" rows="5" :loading="isLoading"
            placeholder="הערה לאדמין עבור יום זה" />
        </b-field>
        <p class="hint">שמירה של הערה ריקה תמחק את ההערה מהיום.</p>
      </section>

      <footer class="modal-card-foot">
        <b-button :loading="isSaving" :disabled="isLoading" type="is-primary" label="שמור" @click="save" />
        <b-button :disabled="isSaving" label="ביטול" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import { ToastProgrammatic as Toast } from "buefy";
import TasksService from "@/services/TasksService";

const MONTHS = ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"];

export default {
  name: "DialogDayComments",
  props: {
    courseId: { type: [Number, String], required: true },
    programTypeId: { type: [Number, String], required: true },
    // "YYYY-MM-DD" — the day being annotated.
    date: { type: String, required: true },
    onSuccess: { type: Function, default: null },
    // Called with (date, comments) once the existing note is read, so the opener can
    // show an indicator for this day even if the dialog is cancelled.
    onLoaded: { type: Function, default: null },
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      comments: "",
    };
  },
  computed: {
    displayDate() {
      const [y, m, d] = this.date.split("-").map(Number);
      return `${d} ${MONTHS[m - 1]} ${y}`;
    },
  },
  created() {
    this.isLoading = true;
    TasksService.getPlanDayComments(this.courseId, this.programTypeId, this.date)
      .then((r) => {
        this.comments = (r.data && r.data.comments) || "";
        if (this.onLoaded) this.onLoaded(this.date, this.comments);
      })
      .catch(() => {
        Toast.open({ type: "is-danger", message: "שגיאה בטעינת ההערה", duration: 5000 });
      })
      .finally(() => { this.isLoading = false; });
  },
  methods: {
    save() {
      this.isSaving = true;
      const text = (this.comments || "").trim();
      TasksService.setPlanDayComments({
        CourseId: Number(this.courseId),
        ProgramTypeId: Number(this.programTypeId),
        TaskDate: this.date,
        Comments: text,
      })
        .then(() => {
          Toast.open({ type: "is-success", message: text ? "ההערה נשמרה." : "ההערה נמחקה.", duration: 4000 });
          if (this.onSuccess) this.onSuccess(this.date, text);
          this.$emit("close");
        })
        .catch(() => {
          Toast.open({ type: "is-danger", message: "שמירת ההערה נכשלה.", duration: 6000 });
        })
        .finally(() => { this.isSaving = false; });
    },
  },
};
</script>

<style scoped lang="scss">
.hint {
  font-size: 12.5px;
  color: #8c9bab;
  margin-top: 6px;
}
</style>
